import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useApi } from "../../lib/api";
import { SectionHead, SampleBadge } from "../Badges";

const BRAND = { "neat-fufu": "neat-foods", "neat-banku": "neat-foods", "this-way": "atona-foods", "u2-salt": "u2-salt", "special-ice": "special-ice" };

export const Products = () => {
  const { data } = useApi("/public/products");
  return (
    <section id="products" className="max-w-7xl mx-auto px-5 md:px-8 py-20" data-testid="products-section">
      <SectionHead eyebrow="Made by DGC" title="From the Ghanaian table to the shelf">
        Neat Foods, Atona, U2 Salt and Special Ice — the everyday brands of the Despite Group.
      </SectionHead>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {(data || []).map((p, i) => (
          <Link to={`/entities/${BRAND[p.id]}`} key={p.id} className={`panel panel-hover overflow-hidden block ${i === 0 ? "lg:col-span-2" : ""}`} data-testid={`product-${p.id}`}>
            <div className="h-48 overflow-hidden relative">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute top-2 left-2"><SampleBadge label="Stock image" /></div>
            </div>
            <div className="p-4">
              <div className="eyebrow !text-[10px]">{p.brand}</div>
              <div className="text-ink font-semibold mt-1">{p.name}</div>
              <div className="text-[11px] text-slate-500 mt-1">{p.entity}</div>
              <div className="mt-3 flex gap-2 text-xs text-slate-400"><MapPin size={14} className="text-gold shrink-0" />{p.where_to_buy}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
